import { createContext } from "react";

import { ScanDetails } from "./hooks/useScan/gql";
import { NewScanScheduleStep } from "./types";

type NewScanScheduleContextProps = {
  currentStep: NewScanScheduleStep;
  currentStepIndex: number;
  isEditMode: boolean;
  scan?: ScanDetails;
  goToStep: (step: NewScanScheduleStep) => void;
  goToNextStep: () => void;
  goToPreviousStep: () => void;
};

export const NewScanScheduleContext = createContext<NewScanScheduleContextProps | undefined>(
  undefined
);
NewScanScheduleContext.displayName = "NewScanScheduleContext";
